export enum ETagType {
  DANGER = 'DANGER',
  WARNING = 'WARNING',
  NORMAL = 'NORMAL',
  SUCCESS = 'SUCCESS',
}
